import AdminService from '@/services/admin/adminService';

export const admin = {
    namespaced: true,
    state: {
    },
    actions: {
        updatePrivacyPolicy({ commit }: any, { id, policyHtml }: any) {
          return AdminService.updatePrivacyPolicy(id, policyHtml)
          .then(success => {
              return Promise.resolve(success);
            },
            error => {
              return Promise.reject(error);
            }
          );
        },
        getPrivacyPolicy({ commit }: any, id: number) {
          return AdminService.getPrivacyPolicy(id).then((success:any) => {
              return Promise.resolve(success);
            },
            (error: any) => {
              return Promise.reject(error);
            }
        );
      },
      getUsers({ commit }: any) {
        return AdminService.getUsers().then((success:any) => {
            return Promise.resolve(success.data);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
      },
      getChildrenOfProvider({ commit }: any, userId: string) {
        return AdminService.getChildrenOfProvider(userId).then((success: any) => {
            return Promise.resolve(success.data);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
      },
      getBookingInfoProvider({ commit }: any, userId: string) {
        return AdminService.getBookingInfoProvider(userId).then((success: any) => {
            return Promise.resolve(success.data);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
      },
      getBookingInfoChild({ commit }: any, { childId, providerId }: any) {
        return AdminService.getBookingInfoChild({ childId: childId, providerId: providerId }).then((success: any) => {
            return Promise.resolve(success.data);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
      },
      deleteUser({ commit }: any, userId: string) {
        return AdminService.deleteUser(userId).then((success:any) => {
            return Promise.resolve(success.data);
          },
          (error: any) => {
            return Promise.reject(error);
          }
        );
      },
      clear({ commit }: any) {
        commit("clear");
      }
    },
    mutations: {
      clear(state: any) {
      }
    }
};